module.exports = "<label data-material=\"All Results\" class=\"js-material all-materials top clearfix\">\r\n    <input type=\"checkbox\">\r\n    <span>All Results</span>\r\n    <span class=\"js-material-count all-results-count\">{{Model.TotalResults}}</span>\r\n</label>\r\n<hr>\r\n<div class=\"children-region clearfix\"></div>\r\n<div class=\"disabled-shield\">Filtering by material type is not possible when there is an explicit material type in the search box</div>"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/material-filter-panel.html
// module id = 417
// module chunks = 1